import * as Images from 'pos/Images';

import * as SalesStore from '../SalesStore';

import { Permission } from 'core/api';
import { Result } from 'core/infrastructure';
import { Preconditions } from 'core/infrastructure-next';
import { Command } from 'pos/common';
import GetSeatNumber from './getSeatNumber';
import { Modal } from 'core/ui-next/modal';

declare global {
	interface CommandType {
		editSeatNumber: () => Promise<Result>
	}
}

Command.register('editSeatNumber', Preconditions.ensure(Permission.Ticket_EditSeatNumber), async (): Promise<Result> => {
	const actualSeatNumber = SalesStore.getSeatNumber();

	const result = await Modal.show(GetSeatNumber, { Icon: Images.SetNextSeatNumber, seatNumber: actualSeatNumber });

	if (!result.ok)
		return result;

	SalesStore.setSeatNumber(result.value);

	return Result.ok();
});